import axios from 'axios'
//import cookie from "@/plugins/cookie";

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})

// Set Authorization header from cookie
//if(cookie.get('login_remember'))
//    instance.defaults.headers.common['Authorization'] = cookie.get('login_remember')

export default instance
